import { default as i18n } from 'i18next';
import { initReactI18next } from 'react-i18next';

import ar from '@locales/ar/translation.json';
import en from '@locales/en/translation.json';

if (!i18n.isInitialized) {
  i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      resources: {
        en: {
          translation: en,
        },
        ar: {
          translation: ar,
        },
      },
      compatibilityJSON: 'v3', // for fixing i18next::pluralResolver: Your environment seems not to be Intl API compatible on android as per docs https://www.i18next.com/misc/migration-guide
      lng: 'en', // if you're using a language detector, do not define the lng option
      supportedLngs: ['ar', 'en', 'dev'],
      debug: true,
      interpolation: {
        escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
      },
    });
}

export { i18n };
